import { User } from '../auth0/User';
import * as actions from './actionTypes/auth.actionType';

export function loginSuccess(user: User): actions.ILoginSuccess {
    return {
        type: actions.LOGIN_SUCCESS,
        payload: { user }
    };
}